import { Sk } from './shared';

const STATS = [
  { k: 'high', label: 'High',         n: 5 },
  { k: 'med',  label: 'Medium',       n: 3 },
  { k: 'low',  label: 'Low',          n: 0 },
  { k: 'na',   label: 'Not relevant', n: 8 },
];

const ROWS = [
  { jur: 'DE', st: 'req',    label: 'Action req.', w1: '88%', w2: '52%' },
  { jur: 'CZ', st: 'review', label: 'Review',      w1: '74%', w2: '44%' },
  { jur: 'SK', st: 'ok',     label: 'Compliant',   w1: '82%', w2: '38%' },
];

export function MkTraffic() {
  return (
    <div className="csmk csmk-traffic">
      <div className="hd">
        <span>Compliance digest</span>
        <span className="date">· 02 JUN 2026</span>
      </div>
      <div className="prio">
        {STATS.map((s) => (
          <div className={`pbox ${s.k}`} key={s.k}>
            <span className="lbl">{s.label}</span>
            <span className="num">{s.n}</span>
          </div>
        ))}
      </div>
      <div className="tlist">
        {ROWS.map((r, i) => (
          <div className="trow" key={i}>
            <span className="jur">{r.jur}</span>
            <span className={`chip ${r.st}`}>{r.label}</span>
            <span className="bubbles">
              <Sk w={r.w1} h="6px" /><Sk w={r.w2} h="6px" />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
